import HttpRouter from "../services/HttpRouter";

export default {
  getPermissions ({}, successCallback) {
    HttpRouter.get(null, 'user/permissions').then(
            function (response) {successCallback(response.data)},
            function (response) {console.error('Problem loading user/permissions', response)})
    },
}
